
const ingredient_items = document.querySelectorAll('.js-ingredient-item');

[...ingredient_items].forEach( function ( ingredient_item ) {

	ingredient_item.innerHTML = ingredient_item.innerHTML.replace('/', '&frasl;');

} )